import React from 'react';

export default function AdContent ({ children }) {
    return (
        <div className="mtt-template-content__sidebar-wrapper mtt-template-content__sidebar-wrapper--ads">
            <div className="mtt-template-content__sidebar mtt-template-content__sidebar--ads">
                { children }
            </div>
        </div>
    )
}
